// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectsTableThead_wrapper__2oNsm","container":"ProjectsTableThead_container__Rnthc"};